import React, {Component} from "react"
import {Link} from "react-router-dom"
import shop from "shop/shop"
import {observer} from "mobx-react"
import {Button, Icon, Popup} from "semantic-ui-react"

import Price from "components/Price/Price"
import MinOrderValue from "components/Cart/MinOrderValue"
import queryString from "qs"

@observer
export default class CartButton extends Component {

	constructor() {
		super()
		this.state = {
			sum: 0
		}
	}

	render() {
		let {sum, loading} = shop.cart
		const MIN_ORDER_VALUE = Number( shop.config.MIN_ORDER_VALUE ) || 0
		const aboveMin = !shop.config.MIN_ORDER_VALUE || (sum > shop.config.MIN_ORDER_VALUE)

		if ( !shop.session ) return null

		return (
			<div className="CartButton relative">
				<Button
					primary
					loading={loading}
					className=""
					{...this.props}
					as={Link}
					to={{
						pathname: `/checkout/`,
						search  : queryString.stringify( {referer: document.location.pathname} )
					}}
					// onClick={app.sidebar.toggle.dispatch}
				>
					<Popup trigger={
						<React.Fragment>
							{aboveMin ? <Icon name="shopping cart" /> : <Icon name={"warning circle"} />}
							{sum > 0 ? <Price>{sum}</Price> : <span><Price>0</Price></span>}
						</React.Fragment>
					}>

						<div>
							{!!MIN_ORDER_VALUE && <span>{translate( "min_order_value" )} <Price>{shop.config.MIN_ORDER_VALUE}</Price></span>}
							{(!MIN_ORDER_VALUE) && <span>Warenkorb anzeigen</span>}
						</div>
					</Popup>
				</Button>
				<div className="absolute left-0 right-0 MinOrderValue-container">
					<MinOrderValue sum={sum} />
				</div>
			</div>
		)
	}
}





// WEBPACK FOOTER //
// ./src/components/Cart/CartButton.js